import {subdomainResource} from './url'
import request from './command'

const {send, open} = XMLHttpRequest.prototype

XMLHttpRequest.prototype.open = function (method, url, ...args) {
  this.requestURL = url
  open.apply(this, [method, url, ...args])
}

window.edusystem = window.edusystem || {}

XMLHttpRequest.prototype.send = function () {
  const setHeader = this.setRequestHeader.bind(this)
  const language = location.hash.substring(2,4)
  setHeader('Accept-Language', language)
  const {session = {}} = edusystem
  if (session.customHeaders)
    Object.entries(session.customHeaders).forEach(([name, value]) => setHeader(name, value))
  const toBosh = /\/chat\./.test(this.requestURL) || /:7070\//.test(this.requestURL)
  if (session.withCredentials !== false && !toBosh)
    this.withCredentials = true
  send.apply(this, arguments)
}

const disabled = process.env.MOXIE_DISABLED == 'true'

function addMoxie () {
  if (!disabled) {
    const script = document.createElement("script")
    script.src = '//' + subdomainResource('moxie','js/moxman.api.min.js')
    return new Promise((resolve,reject) => {
      script.onerror = reject
      script.onload = resolve
      document.body.appendChild(script)
    })
  } else {
    return new Promise (resolve => resolve(true))
  }
}

const loadMoxie = addMoxie()

export default loadMoxie
